import { render, staticRenderFns } from "./NewCoverageAreas.vue?vue&type=template&id=7836c265"
import script from "./NewCoverageAreas.vue?vue&type=script&lang=js"
export * from "./NewCoverageAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports